import { FormationDetailProps } from "@/types/formation";

export const detecteurGazFormation: FormationDetailProps = {
  id: "11",
  title: "Formation Détecteur de Gaz",
  description: "Cette formation permet de connaître les risques spécifiques liés aux gaz et d'apprendre à utiliser un détecteur de gaz en toute sécurité.",
  duration: "4 heures (1/2 journée)",
  category: "Sécurité",
  imageSrc: "/images/formations/detecteurgaz.webp",
  slug: "detecteur-gaz",
  reference: "F-DETEC",
  price: "Sur devis – nous contacter",
  targetAudience: "Toute personne utilisant un détecteur mono gaz ou multi gaz",
  prerequisites: "Être âgé de 18 ans\nÊtre apte médical",
  objectives: [
    "Identifier les risques spécifiques liés au gaz",
    "Appliquer les procédures préalables à toute intervention",
    "Utiliser les équipements de sécurité et vérifier leur bon fonctionnement",
    "Intervenir en cas d'alerte au gaz (détecter / informer / contrôler)"
  ],
  program: [
    {
      title: "Partie théorique 50%",
      items: [
        "Identification des risques des gaz",
        "Sécurité et respect des obligations",
        "Technologie de détection",
        "Utilisation des appareils",
        "Procédures et stratégies"
      ]
    },
    {
      title: "Partie pratique 50%",
      items: [
        "Vérification des appareils de détection",
        "Manipulation des appareils",
        "Démonstration des appareils sur site"
      ]
    }
  ],
  pedagogicalMethods: [
    "Exposés interactifs, démonstrations par le formateur, exercice sur site"
  ],
  evaluationMethods: [
    "En 1er jour de la formation : Questionnaire des besoins et positionnement de l'apprenant",
    "Pendant la formation : Atelier pratique en situation réelle + exercices applicatifs",
    "Fin de formation : QCM pour évaluation des acquis + évaluation de satisfaction à chaud",
    "Après la formation : Évaluation à froid pour vérifier les compétences de l'apprenant"
  ],
  certification: "Cette action de formation sera validée par un certificat de réalisation nominative, après la réalisation du QCM final par l'évaluation des acquis.",
  registrationProcess: [
    "Inscription par téléphone, par mail ou par le site internet",
    "Délai d'accès selon un agenda interne de session de l'entreprise",
    "Inscription 15 jours avant le début de la formation"
  ],
  accessibilityCriteria: "Pour toute personne en situation d'handicap, Nous sommes susceptibles d'accueillir les personnes moins de nous contacter au préalable pour étudier toute situation.",
  formatterInfo: {
    name: "Sebastien Davrainville - SDPSI Formation",
    phone: "06.22.61.04.09",
    email: "sdpsiformation@orange.fr",
    website: "www.sdpsi-formations.fr"
  }
};
